import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken, isSignedIn } = useAuth();
  return useCallback(
    async (method, url, data) => {
      const headers = {};
      if (isSignedIn) {
        const t = await getToken();
        if (t) headers.Authorization = `Bearer ${t}`;
      }
      const r = await axios({ method, url: API + url, data, headers });
      return r.data;
    },
    [getToken, isSignedIn]
  );
}

export function errMsg(e, fallback = "Ha ocurrido un error. Inténtalo de nuevo.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) return (d[0].msg || fallback).replace(/^Value error, /, "");
  if (e?.message === "Network Error") return "Sin conexión con el servidor. Revisa tu conexión.";
  return fallback;
}

export const euro = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const DAY_NAMES = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
export const DAY_SHORT = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
export const MONTHS_SHORT = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export const ADDRESS = "Mirakruz Kalea, 17, Bajo, Donostia / San Sebastián, Gipuzkoa, España";
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;
export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`;

export const waLink = (num) => {
  const d = (num || "").replace(/\D/g, "");
  return d ? `https://wa.me/${d}` : "";
};

export const STATUS = {
  pending: { label: "Pendiente", cls: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  confirmed: { label: "Confirmada", cls: "bg-[#111111] text-white border-[#111111]" },
  completed: { label: "Completada", cls: "bg-white text-[#111111] border-[#111111]" },
  cancelled: { label: "Cancelada", cls: "bg-white text-zinc-400 border-zinc-200 line-through" },
};

export function ymd(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
